import React, { memo } from "react";
import { NavLink } from "react-router-dom";
import { Row ,Col,Card} from 'react-bootstrap';

const TestResume = memo( function TestResume({ mockId }) {

	return (
		<div className="content questionsArea deviceTestPage">
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className='testFinish unselectable'>
								<div className="col-sm-12">
									<h4 className="mt-0">Test Pending</h4>
									<p>
										<span>
											This mock is unfinished. Please
											{/* <NavLink to={`/admin/fulltest/${mockId}/1`} > */}
											<NavLink to={`/admin/pending`} >
											
											
												<button className="btn">Continue</button>
											</NavLink>
											 {/* <a href={`/admin/fulltest/${mockId}/1`}>
												<button className="btn">Continue</button>
											</a>  */}
											to resume this test.
										</span>
									</p>
								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</div>
	);
});

export default TestResume;